import React from 'react';
interface UptimeChartProps {
  values: number[];
  height?: number;
  label: string;
}

/**
 * Hand-drawn response-time chart. Failed checks (0ms) are drawn as red
 * downtime bands rather than as a line dropping to the floor, because a
 * line at zero reads as "instant response", which is the opposite of true.
 */
export function UptimeChart({
  values,
  height = 168,
  label
}: UptimeChartProps) {
  const width = 720;
  const max = Math.max(...values.filter(v => v > 0), 1) * 1.15;
  const step = values.length > 1 ? width / (values.length - 1) : width;
  const linePoints = values.map((value, index) => {
    if (value === 0) {
      return null;
    }
    const x = index * step;
    const y = height - value / max * height;
    return `${x.toFixed(1)},${y.toFixed(1)}`;
  }).filter((point): point is string => point !== null);
  const areaPath = linePoints.length > 1 ? `M ${linePoints[0]} L ${linePoints.slice(1).join(' L ')} L ${(values.length - 1) * step},${height} L 0,${height} Z` : '';
  const downtimeBands: {
    start: number;
    end: number;
  }[] = [];
  let bandStart: number | null = null;
  values.forEach((value, index) => {
    if (value === 0 && bandStart === null) {
      bandStart = index;
    }
    if (value !== 0 && bandStart !== null) {
      downtimeBands.push({
        start: bandStart,
        end: index
      });
      bandStart = null;
    }
  });
  if (bandStart !== null) {
    downtimeBands.push({
      start: bandStart,
      end: values.length - 1
    });
  }
  return <figure className="m-0" data-id="element-452" data-mp="18e1725bypqiv">
      <svg viewBox={`0 0 ${width} ${height}`} className="h-auto w-full" style={{
      height
    }} role="img" aria-label={label} preserveAspectRatio="none" data-id="element-453" data-mp="18fc9a0preq7v">
        {[0.25, 0.5, 0.75].map(fraction => <line key={fraction} x1={0} x2={width} y1={height * fraction} y2={height * fraction} stroke="#dce2ce" strokeWidth={1} data-id="element-454" data-mp="kneymcy1q48c" />)}

        {downtimeBands.map(band => <rect key={`${band.start}-${band.end}`} x={band.start * step} width={Math.max(step, (band.end - band.start) * step)} y={0} height={height} fill="#fcecec" data-id="element-455" data-mp="2mlh0vxg1wfln" />)}

        {areaPath && <path d={areaPath} fill="#e7f1ec" data-id="element-456" data-mp="2difyo7ub38n9" />}
        {linePoints.length > 1 && <polyline points={linePoints.join(' ')} fill="none" stroke="#14503a" strokeWidth={2} strokeLinejoin="round" strokeLinecap="round" vectorEffect="non-scaling-stroke" data-id="element-457" data-mp="3aa0b4iinv2gd" />}
      </svg>
    </figure>;
}